import {getPhoneDataFromString} from "../../../form/utils/get_phone_data_from_string";
import {IApplicationFormValues} from "../../types/form/IApplicationFormValues";
import {ISentLeadStoredValues} from "../../types/lead/ISentLeadStoredValues";

export function getLeadFormValuesFromStorage(storagedLeadFormValues: ISentLeadStoredValues, defaultFormValues: IApplicationFormValues): IApplicationFormValues {
    const fieldsToBeRestored: (keyof ISentLeadStoredValues)[] = ["name", "email", "phone", "marketing_email", "marketing_sms"];

    const storageValues = fieldsToBeRestored.reduce<IApplicationFormValues>(
        (previousValue, currentValue) => {
            return {
                ...previousValue,
                [currentValue]: storagedLeadFormValues[currentValue]
            };
        },
        {...defaultFormValues}
    );

    storageValues.phone = getPhoneDataFromString(storagedLeadFormValues.phone);

    return storageValues;
}
